import React from 'react';

import './contactBody.scss';

const ContactBody = () => {
    return (
        <>
        <div className='contact-body'></div>
        <div className='contact_text'>
        "We are entering an era when we shall create resources which shall be so constantly renewed that the only loss will be not to use them.
        <br/> There will be such a plenteous supply of services, that it will be a sin not to use all we want. This era is coming now.
        </div>
        </>
           
    )
}

export default ContactBody;
